import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../constants';
import { useAddressLabel } from '../../hooks/use-address-label';
import { TextField } from '../../ui/text-field';
import { COUNTRY_CODES } from '../mla-country/country-codes';
import { useCountryCode } from '../multiline-address/multiline-address/country-code-context';
import JapanPostalCode from './japan-postal-code';
import { useExperiments } from '../../contexts/experiments-context';
const MlaPostalCode = props => {
  const fieldType = FIELD_TYPES.MLA_POSTAL_CODE;
  const label = useAddressLabel('zipCode');
  const {
    isExperimentEnabled
  } = useExperiments();
  const isJapanAutocompleteEnabled = isExperimentEnabled('specs.forms.JapanAutocompleteEnabled');
  const countryCode = useCountryCode();
  const isJapan = Boolean(countryCode && COUNTRY_CODES[countryCode] === COUNTRY_CODES.JP);
  return isJapan && isJapanAutocompleteEnabled ? /*#__PURE__*/React.createElement(JapanPostalCode, _extends({}, props, {
    fieldType: fieldType,
    label: label
  })) : /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
    fieldType: fieldType,
    label: label
  }));
};
export default MlaPostalCode;
//# sourceMappingURL=mla-postal-code.js.map